import { atom } from "jotai";
import type { DashboardScopeSelection } from "../types";

/**
 * Who every analytics widget on the dashboard (Overview + Activity) is scoped
 * to. `me` is the signed-in resource, `all` is every team member, `resources`
 * is an explicit set. Resources are kept whole rather than as bare ids so the
 * filter and the section headings can label themselves without refetching.
 */
export const dashboardScopeAtom = atom<DashboardScopeSelection>({ mode: "me" });
